<template>
    <v-btn
            :block="block"
            :max-width="maxWidth"
            :width="width"
            :min-width="minWidth"
            :depressed="depressed"
            :outlined="outlined"
            :disabled="disabled"
            :to="link"
            @click="handleClick"
    >{{ content }}</v-btn
    >
</template>

<script>
    export default {
        name: "Button",
        props: {
            width: String,
            minWidth: String,
            maxWidth: String,
            depressed: {
                type: Boolean,
                default: true
            },
            outlined: {
                type: Boolean,
                default: false
            },
            disabled: Boolean,
            link: String,
            content: String,
            block: Boolean
        },
        methods: {
            handleClick() {
                this.$emit("onClick");
            }
        }
    };
</script>
